'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import memoize from 'transmute/memoize';
import partial from 'transmute/partial';
import { Component } from 'react';
export default function withPartials(WrappedComponent) {
  class WithPartialsWrapper extends Component {
    constructor(props) {
      super(props);
      this.partial = memoize(partial);
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        partial: this.partial
      }));
    }

  }

  WithPartialsWrapper.displayName = `WithPartials(${WrappedComponent.name})`;
  WithPartialsWrapper.wrappedComponent = WrappedComponent;
  return WithPartialsWrapper;
}